import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "com_title1" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "お知らせ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "text" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text__item" }, "一覧はこちら"),
  /*#__PURE__*/_createElementVNode("span", {
    class: "text__item",
    "aria-hidden": "true"
  }, "一覧はこちら")
], -1)
const _hoisted_4 = { class: "com_topic_list1" }
const _hoisted_5 = { class: "meta1" }
const _hoisted_6 = { class: "date1 roboto" }
const _hoisted_7 = { class: "com_tag1" }
const _hoisted_8 = { class: "body1" }
const _hoisted_9 = {
  key: 0,
  class: "com_icon_doc1"
}
const _hoisted_10 = {
  key: 1,
  class: "com_icon_new"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h2", _hoisted_1, [
      _hoisted_2,
      _createVNode(_component_router_link, {
        to: "/news",
        class: "button1"
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.infoListData, (info) => {
        return (_openBlock(), _createElementBlock("div", {
          key: info.contentId
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(info.postPeriod), 1),
            _createElementVNode("span", _hoisted_7, _toDisplayString(info.subCategoryName), 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_router_link, {
              to: `/${info.detailPath}/categoryId/${info.categoryId}/contentsId/${info.contentId}`,
              class: "com_link1"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(info.contentsTitle), 1)
              ]),
              _: 2
            }, 1032, ["to"]),
            (info.fileFlg)
              ? (_openBlock(), _createElementBlock("span", _hoisted_9))
              : _createCommentVNode("", true),
            (info.newFlg)
              ? (_openBlock(), _createElementBlock("span", _hoisted_10, "NEW"))
              : _createCommentVNode("", true)
          ])
        ]))
      }), 128))
    ])
  ], 64))
}